import { render, staticRenderFns } from "./nbyx-tabs.vue?vue&type=template&id=ebeadb52&scoped=true&"
import script from "./nbyx-tabs.vue?vue&type=script&lang=js&"
export * from "./nbyx-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebeadb52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebeadb52')) {
      api.createRecord('ebeadb52', component.options)
    } else {
      api.reload('ebeadb52', component.options)
    }
    module.hot.accept("./nbyx-tabs.vue?vue&type=template&id=ebeadb52&scoped=true&", function () {
      api.rerender('ebeadb52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/nbyx-tabs.vue"
export default component.exports